
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { StateResponse } from '../interfaces/iGridDeviceState';

@Injectable({
  providedIn: 'root',
})
export class SystemStateService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  private readonly baseUrl = environment.serverUrl;

  public getState(deviceId: string, systemTypeId: number, serialNumber: string): Observable<StateResponse> {
    const url =
      `${this.baseUrl}/api/igrid/system/device/${deviceId}/DisSync` + `?systemTypeId=${systemTypeId}&serialNumber=${serialNumber}`;
    return this.httpClient.get<StateResponse>(url);
  }
}
